import { create } from 'zustand';

interface DeliveredPack {
  packId: string;
  purchaseId: string;
  deliveredAt: number;
}

interface PackNotificationStore {
  deliveredPacks: DeliveredPack[];

  // Actions
  addDeliveredPacks: (purchaseId: string, packIds: string[]) => void;
  removeDisplayedPack: (packId: string) => void;
  clearAllPacks: () => void;
}

export const usePackNotificationStore = create<PackNotificationStore>((set) => ({
  deliveredPacks: [],

  addDeliveredPacks: (purchaseId: string, packIds: string[]) => {
    set((state) => {
      const newPacks = packIds.map((packId) => ({
        packId,
        purchaseId,
        deliveredAt: Date.now(),
      }));

      return {
        deliveredPacks: [...state.deliveredPacks, ...newPacks],
      };
    });
  },

  removeDisplayedPack: (packId: string) => {
    set((state) => ({
      deliveredPacks: state.deliveredPacks.filter((pack) => pack.packId !== packId),
    }));
  },

  clearAllPacks: () => {
    set({ deliveredPacks: [] });
  },
}));
